module.exports = "pegasus/assets/background-patterns/shl.png";